import { Box } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import { urlConfig } from '../../../../config/urlConfig';
import { CreateMeetingContext } from '../../../../services/create-meeting/create-meeting.context';
import {
  accessTokenRequest,
  getUserData,
  sendRequest,
} from '../../../../services/global/global.service';
import { ProfileContext } from '../../../../services/profile/profile.context';
import validator from 'validator';
import { InvitedUserComponent } from './invited-user.component';

export const Invitation = ({ id }) => {
  const { user = '' } = useContext(ProfileContext);
  const { states: createMeetingStates } = useContext(CreateMeetingContext);

  const { usersInfo, users, setUsers, setUsersInfo, meeting } =
    createMeetingStates;

  const [value, setValue] = useState('');
  const [error, setError] = useState(null);
  const [searchList, setSearchList] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [isEmail, setIsEmail] = useState(false);
  const [notFound, setNotFound] = useState(false);

  const getUsers = () => {
    const usersDataArr = [];

    accessTokenRequest()
      .then((response) => {
        getUserData()
          .then((e) => {
            e.data.members.map((item) =>
              usersDataArr.push({
                username: item.username,
                fname: item.first_name,
                lname: item.last_name,
                email: item.email,
                avatar: item.avatar,
              })
            );
            setAllUsers(usersDataArr);
          })
          .catch(console.log);
      })
      .catch(console.log);
  };

  const convertCase = (arr) => {
    return arr.map((i) => i.toLowerCase());
  };

  // get user data for show on map
  const getUsersData = (members) => {
    let data = null;
    let newMembers = [];

    members && members.map((i) => newMembers.push(i.username));

    if (user) {
      data =
        newMembers.length > 0
          ? convertCase([...newMembers, user.username])
          : convertCase([user.username]);
    }


    if (data) {
      accessTokenRequest()
        .then((response) => {
          sendRequest(urlConfig.get_user_data, response, 'post', {
            users: data,
          })
            .then((res) => {
              res.data &&
                res.data.members &&
                res.data.members.length > 0 &&
                setUsersInfo(res.data.members);
            })
            .catch(console.log);
        })
        .catch(console.log);
    }
  };

  const handleChange = (e) => {
    setError(null);
    setValue(e.target.value.trim());
    onSearch(e.target.value.trim(), users);
  };

  const setLocalStorage = (members) => {
    localStorage.setItem('users', JSON.stringify(members));
  };

  const valueChecker = (value) => {
    return searchList.some((e) => e.username === value || e.email === value);
  };

  const findUser = (val, findSearchTerm, onBlur) => {
    let user = null;
    if (findSearchTerm) {
      if (onBlur) {
        user = allUsers.filter((i) => i.username === val || i.email === val);
      } else {
        user = allUsers.filter(
          (i) => i.username === val || i.email === val
        );
      }
    }
    return user;
  };

  const addSearchTerm = (val, onBlur) => {
    if (val) {
      let newUsers = null;

      const findSearchTerm = allUsers.some(
        (i) => i.username.includes(val) || i.email.includes(val)
      );

      let user = findUser(val, findSearchTerm, onBlur);

      if (findSearchTerm && user && user.length > 0) {
        newUsers = {
          username: user[0].username,
          email: user[0].email,
          avatar: user[0].avatar,
          fname: user[0].fname,
          lname: user[0].lname,
          isValid: true,
        };
      } else {
        newUsers = {
          username: val.toLowerCase(),
          email: val.toLowerCase(),
          fname: null,
          lname: null,
          avatar: null,
          isValid: validator.isEmail(val.toLowerCase()) ? true : false,
        };
      }

      if (!isExist(val)) {
        setValue('');
        setError(null);

        if (valueChecker(val)) {
          //valid username
          !id && setLocalStorage([...users, newUsers]);
          setUsers([...users, newUsers]);

          getUsersData([...users, newUsers]);
        } else if (validator.isEmail(val)) {
          //valid email
          !id && setLocalStorage([...users, newUsers]);
          setUsers([...users, newUsers]);
          getUsersData([...users, newUsers]);
        } else {
          !id && setLocalStorage([...users, newUsers]);
          setUsers([...users, newUsers]);
        }
      }
    }
  };

  const onSearch = (value, users) => {
    let newArr = null;
    const searchTerm = value.toLowerCase();

    newArr = allUsers
      .filter(
        (item) =>
          !users.find(
            (u) => u.email === item.email || u.username === item.username
          )
      )
      .map((i) => i);

    setSearchList(newArr);

    const checker = newArr.some(
      (item) =>
        item.username.toLowerCase().includes(searchTerm) ||
        item.email.toLowerCase().includes(searchTerm)
    );

    if (checker) {
      setIsEmail(false);
      setNotFound(false);
    } else if (!checker && validator.isEmail(searchTerm)) {
      setIsEmail(true);
      setNotFound(false);
    } else {
      setIsEmail(false);
      setNotFound(true);
    }
  };

  const handleKeyDown = (e) => {
    if (['Enter', 'Tab', ',', ' '].includes(e.key)) {
      e.preventDefault();
      addSearchTerm(e.target.value.trim().toLowerCase(), false);
    }
  };

  const handleDelete = (data) => {
    const newUsers = users.filter((i) => i.username !== data);
    setUsers(newUsers);

    const newUsersInfo = usersInfo.filter(
      (i) => i.username !== data && i.email !== data
    );
    setUsersInfo(newUsersInfo);

    !id && setLocalStorage(newUsers);
  };

  const isExist = (data) => {
    let isInList = true;

    if (users.some((user) => user.username === data || user.email === data)) {
      isInList = true;
    } else {
      isInList = false;
    }

    if (isInList) {
      setError(value);
      return true;
    } else if (user.username.includes(data)) {
      setError(user.username);
      return true;
    } else {
      return false;
    }
  };

  const handleClick = (item, e) => {
    const newUsers = users.filter((i) => i.username !== item);

    setUsers(newUsers);

    setValue(item);

    if (
      allUsers.some((user) => user.username === item || user.email === item)
    ) {
      setSearchList([...searchList, item]);
    }

    onSearch(item, newUsers);

    !id && setLocalStorage(newUsers);
  };

  const getUsersUid = (meeting) => {
    let members = [];

    meeting.members.map((i) => {
      if (i.member_uuid && i.member_uuid !== null) {
        members.push(i.member_uuid);
      }
      return null;
    });

    members && members.length > 0 && getInvitedUsersData(members);
  };

  const addUsers = (meeting, data) => {
    const newUsersArr = [];
    const newNonMemberArr = [];

    const non_member = meeting.members
      .filter((item) => item.member_uuid === null)
      .map((i) => i);

    data &&
      data.map((i) => {
        if (i.username !== user.username || i.email !== user.email) {
          newUsersArr.push({
            username: i.username,
            email: i.email,
            avatar: i.avatar,
            fname: i.first_name,
            lname: i.last_name,
            isValid: true,
          });
        }
      });

    newUsersArr.length > 0 && setUsers(newUsersArr);

    if (non_member && non_member.length > 0) {
      non_member.map((i) =>
        newNonMemberArr.push({
          username: i.email,
          email: i.email,
          avatar: null,
          fname: null,
          lname: null,
          isValid: true,
        })
      );
      setUsers([...newUsersArr, ...newNonMemberArr]);
    }
  };

  const getInvitedUsersData = (users) => {
    accessTokenRequest()
      .then((response) => {
        getUserData({ users_uuids: users }, response).then((res) => {
          if (res.data && res.data.members) {
            setUsersInfo(res.data.members);
            addUsers(meeting, res.data.members);
          }
        });
      })
      .catch((e) => {
        console.log('users data error', e.response);
      });
  };

  //create meeting
  useEffect(() => {
    const localEmail = JSON.parse(localStorage.getItem('users'));

    getUsers();
    if (!id) {
      setError(null);
      setValue('');

      if (localEmail && localEmail.length > 0) {
        setUsers(localEmail);
        getUsersData([...localEmail]);
      } else {
        user && getUsersData(null);
      }
    }
  }, [id, user]);

  //update meeting
  useEffect(() => {
    if (id) {
      meeting && user && getUsersUid(meeting);
      users && setError(null);
    }
    return false;
  }, [id, meeting, user]);

  const functions = {
    handleChange,
    handleKeyDown,
    handleDelete,
    handleClick,
    addSearchTerm,
  };

  const states = {
    value,
    error,
    id,
    searchList,
    isEmail,
    notFound,
  };

  return (
    <Box mt={3}>
      <InvitedUserComponent functions={functions} states={states} />
    </Box>
  );
};
